import { render, staticRenderFns } from "./PH1Z.vue?vue&type=template&id=3952e863&scoped=true"
import script from "./PH1Z.vue?vue&type=script&lang=js"
export * from "./PH1Z.vue?vue&type=script&lang=js"
import style0 from "./PH1Z.vue?vue&type=style&index=0&id=3952e863&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3952e863",
  null
  
)

export default component.exports